import React from 'react';

/**
 * A helper component to be used in Gatsby's code samples:
 * <State initial={{value: 1}}>
 *   {([state, setState]) => <Input defaultValue={state.value} />}
 * </State>
 */
export const State = (props) => props.children(React.useState(props.initial));
